import React from 'react';
import PropTypes from 'prop-types';
import { Button, DropdownButton, MenuItem } from 'react-bootstrap';
import ButtonWithLoader from 'components/ButtonWithLoader/ButtonWithLoader';
import { getFirstName } from 'helpers/portfolioLayout';
import './HireButton.css';

const HireButton = ({
  user,
  loggedInUser,
  currentUser,
  pitches,
  onAccept,
  existingBriefs,
  onHire,
  onHireByDay,
  style,
  isLoadingOwnBriefs,
  className = '',
}) => {
  const getName = user ? getFirstName(user.displayname) : 'me';
  const buttonClass = `hire-button ${className}`;

  // Show loading state if own briefs are still loading
  if (isLoadingOwnBriefs) {
    return (
      <ButtonWithLoader
        bsStyle="primary"
        style={style}
        loading={true}
        text={`Contact ${getName}`}
        onClick={() => {}}
        className={buttonClass}
        disabled={true}
      />
    );
  }

  const hasPitchesButton =
    pitches &&
    (pitches.length > 1 ? (
      <DropdownButton
        title={'Hire ' + getName}
        id="acceptme"
        bsStyle="primary"
        style={style}
        className={buttonClass}
      >
        {pitches.map((pitch, key) => (
          <MenuItem
            key={key}
            onClick={() => onAccept(pitch.message)}
            eventKey={key}
          >
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {pitch.message.text}
            </div>
          </MenuItem>
        ))}
      </DropdownButton>
    ) : (
      <Button
        onClick={() => onAccept(pitches[0].message)}
        bsStyle="primary"
        style={style}
        className={buttonClass}
      >
        Hire {getName}
      </Button>
    ));

  const hasMoreThanOneBriefsButton = existingBriefs &&
    typeof existingBriefs[0] === 'object' &&
    existingBriefs[0].hasOwnProperty('text') && (
      <DropdownButton
        title={'Contact ' + getName}
        id="hireme"
        bsStyle="primary"
        style={style}
        className={buttonClass}
      >
        {/* <MenuItem eventKey="1" onClick={() => onHireByDay(null)}>
          Pay for ongoing work
        </MenuItem>
        <MenuItem divider /> */}
        <MenuItem eventKey="2" onClick={() => onHire(null)}>
          Contact for new project
        </MenuItem>
        <MenuItem divider />
        <MenuItem header eventKey="3">
          Request application to:
        </MenuItem>
        {existingBriefs.map((brief, key) => (
          <MenuItem key={key} onClick={() => onHire(brief)} eventKey={key}>
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '200px',
              }}
            >
              {brief.text}
            </div>
          </MenuItem>
        ))}
      </DropdownButton>
    );

  const hasOneExistingBriefButton = existingBriefs &&
    typeof existingBriefs[0] === 'object' &&
    existingBriefs[0].hasOwnProperty('text') && (
      <Button
        onClick={() => onHire(existingBriefs[0])}
        bsStyle="primary"
        style={style}
        className={buttonClass}
      >
        Invite
      </Button>
    );

  // Show the button if the user is looking at a freelancers portfolio, and it is not their own
  const showButton = user && !currentUser && user.type === 'seller';
  const hasPitches = pitches && pitches.length > 0;
  const hasOneExistingBrief = existingBriefs && existingBriefs.length === 1;
  const hasMoreThanOneExistingBriefs =
    existingBriefs && existingBriefs.length >= 2;

  return showButton ? (
    hasPitches ? (
      hasPitchesButton
    ) : hasOneExistingBrief ? (
      hasOneExistingBriefButton
    ) : hasMoreThanOneExistingBriefs ? (
      hasMoreThanOneBriefsButton
    ) : loggedInUser ? (
      <Button
        title={'Contact ' + getName}
        id="hireme"
        onClick={() => onHire(null)}
        bsStyle="primary"
        style={style}
        className={buttonClass}
      >
        Contact {getName}
      </Button>
    ) : (
      <Button
        onClick={() => onHire(null)}
        bsStyle="primary"
        style={style}
        className={buttonClass}
      >
        Contact {getName}
      </Button>
    )
  ) : (
    <noscript />
  );
};

HireButton.propTypes = {
  user: PropTypes.object,
  loggedInUser: PropTypes.object,
  currentUser: PropTypes.bool,
  pitches: PropTypes.array,
  onAccept: PropTypes.func,
  existingBriefs: PropTypes.array,
  onHire: PropTypes.func,
  onHireByDay: PropTypes.func,
  style: PropTypes.object,
  isLoadingOwnBriefs: PropTypes.bool,
  className: PropTypes.string,
};

export default HireButton;
